import { render, staticRenderFns } from "./Canvas.vue?vue&type=template&id=8592ad88&scoped=true&"
import script from "./Canvas.vue?vue&type=script&lang=js&"
export * from "./Canvas.vue?vue&type=script&lang=js&"
import style0 from "./Canvas.vue?vue&type=style&index=0&id=8592ad88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8592ad88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/laveto/new.laveto.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8592ad88')) {
      api.createRecord('8592ad88', component.options)
    } else {
      api.reload('8592ad88', component.options)
    }
    module.hot.accept("./Canvas.vue?vue&type=template&id=8592ad88&scoped=true&", function () {
      api.rerender('8592ad88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "galaxy/modules/Canvas/resources/js/editor/admin/Canvas.vue"
export default component.exports